// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bz-alert[data-v-9174515a]{display:grid;grid-template-columns:2rem 1fr;-moz-column-gap:.625rem;column-gap:.625rem;align-items:start;justify-items:start;padding:.625rem 1.5625rem;width:100%;background:#fde8e8;border-radius:.375rem}.bz-alert-message[data-v-9174515a]{font-size:1rem;line-height:1.75rem;letter-spacing:.03125rem;color:#ff0f0f}.bz-alert-icon[data-v-9174515a]{color:#ff0f0f}", ""]);
// Exports
module.exports = exports;
